import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  designLinkAnchorTag: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    height: '100%',
  },
  designLinkCard: {
    width: '100%',
    height: '100%',
    minHeight: 240,
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontFamily: theme.gh_vars.circular,
    textDecoration: 'none !important',
    padding: theme.spacing(3, 1.5),
    backgroundColor: '#4F6066',
    border: '1px solid #EBEBEB',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4.5, 3),
      minHeight: 305,
    },
  },
  designLinkTextTitle: {
    color: '#FFFFF0',
    fontSize: 24,
    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 32,
    }            
  },
  designLinkTextBody: {
    color: '#FFFFF0',
    fontWeight: 400,
    textDecoration: 'underline',
    fontSize: 16,
    lineHeight: 1.4,
    [theme.breakpoints.up('sm')]: {
      fontSize: 18
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      lineHeight: 1.8,
    }
  }
}));
